"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useInterval_1 = __importDefault(require("./useInterval"));
var get_1 = __importDefault(require("./utils/get"));
var isFunction_1 = __importDefault(require("./utils/isFunction"));
var addInterval = function (callback, delay, additionalDependenciesThatShouldTriggerResettingInterval) {
    if (additionalDependenciesThatShouldTriggerResettingInterval === void 0) { additionalDependenciesThatShouldTriggerResettingInterval = []; }
    return function (props) {
        useInterval_1.default(callback(props), isFunction_1.default(delay) ? delay(props) : delay, additionalDependenciesThatShouldTriggerResettingInterval.map(function (dependency) {
            return get_1.default(dependency, props);
        }));
        return props;
    };
};
exports.default = addInterval;
